export default "__VITE_ASSET__521bcb97__"